import classNames from 'classnames';
import React, { FC } from 'react';

import useStyles from './styles';

export interface StyledIconProps {
  className?: string;
}

export const StyledIcon: FC<StyledIconProps> = ({ children, className }) => {
  const classes = useStyles();

  return <div className={classNames(classes.container, className)}>{children}</div>;
};

export default StyledIcon;
